import { Component, Input } from '@angular/core';
import { MbAdvice } from '@am/moebius';

@Component({
  selector: 'am-banner-dollar',
  styleUrls: ['./banner-dollar.component.scss'],
  templateUrl: './banner-dollar.component.html',
  imports: [MbAdvice],
})
export class BannerDollarComponent {
  @Input() public isMobile = false;
  constructor() {}
}
